<template>
  <div v-if="hero" id="hud-innate" :class="$style.container">
    <innate-tooltip :hero="hero.name" position="top" />
  </div>
</template>

<script>
import InnateTooltip from '../tooltips/innate-tooltip.vue'

export default {
  name: 'hud-innate',
  components: { InnateTooltip },
  computed: {
    hero() {
      return this.$store.getters.selectedPlayer.hero
    }
  }
}
</script>

<style lang="scss" module>
.container {
  position: absolute;
  top: 0.35vw;
  left: 14.4vw;
  height: 3.4vw;
  width: 1.8vw;
  border-radius: 0.4vw;
  cursor: pointer;
}
</style>
